import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconDeck = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconDeck",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M440-120v-480H143q-15 0-19-14t8-22l325-228q11-8 23-8t23 8l325 228q12 8 8 22t-19 14H520v480q0 17-11 29t-29 11-28-11-12-29m-320 0v-170L95-427q-3-17 6-30t26-16q16-3 30 7t16 25l23 121h124q17 0 29 12t11 28v160q0 17-11 29t-29 11-28-11-12-29v-120h-80v120q0 17-11 29t-29 11-28-11-12-29m480 0v-160q0-17 12-28t28-12h124l23-121q3-16 16-25t30-7 26 16 6 30l-25 137v170q0 17-11 29t-29 11-28-11-12-29v-120h-80v120q0 17-11 29t-29 11-28-11-12-29"
  })
}));